var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var Mssg = dynamicRequire('Mssg.jsx');

class Accessory extends React.Component {

    render() {
        return <div>{this.props.accessory.map((accessoryItem) => {
            var description = accessoryItem.description?accessoryItem.description:<Mssg __key={'nc_casefactory.part.description.' + accessoryItem.articleNumber} />;
            var label = accessoryItem.partName?accessoryItem.partName:<Mssg __key={'nc_casefactory.part.name.' + accessoryItem.articleNumber} />;
            var image = this.props.basePath + '/images/partImages/small/' + accessoryItem.articleNumber + '.jpg'
            var type = this.props.accessory.length > 1 ? 'radio' : 'checkbox';
            return <div className="lr-casefactory-choices-part-picker-part part" key={accessoryItem.id}>
                <label className="lr-casefactory-choices-part-picker-part-name name">
                    <input
                        type={type}
                        name={accessoryItem.id}
                        onChange={() => this.context.emitter.emit('part', accessoryItem, this.isAccessoryChecked(accessoryItem))}
                        checked={this.isAccessoryChecked(accessoryItem)}
                        className="lr-casefactory-choices-part-picker-part-input input"/>
                    <span className="lr-casefactory-choices-part-picker-part-text-label label">{label}</span>
                </label>
                <label className="lr-casefactory-choices-part-picker-part-image-label label">
                    <img src={image}
                         className="lr-casefactory-choices-part-picker-part-image image"/>
                </label>

                <p className="lr-casefactory-choices-part-picker-part-description description">
                    {description}
                </p>
            </div>
        })}
        </div>
    }
    isAccessoryChecked(accessoryItem) {
        return values(this.props.case.accessories).indexOf(accessoryItem.id) !== -1
    }
}

function values(object) {
    return Object.keys(object).map(key => {
        return object[key];
    });
}

Accessory.contextTypes = {
    emitter: React.PropTypes.object.isRequired,
};


module.exports = Accessory;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Options/Accessory.jsx